export default function isLeftClickEvent(event) {
  return !event.button;
}
